// src/pages/PaymentCallback.js
import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { Spinner, Alert, Button, Container, Card } from 'react-bootstrap';
import api from '../services/api';
import './PaymentCallback.css';

const PaymentCallback = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [status, setStatus] = useState('verifying'); // verifying, success, failed
    const [error, setError] = useState('');

    const paymentLinkStatus = searchParams.get('razorpay_payment_link_status');
    const paymentId = searchParams.get('razorpay_payment_id');
    const sessionUuid = searchParams.get('session_uuid');

    useEffect(() => {
        let isMounted = true;
        let pollInterval;

        const checkUnlockStatus = async () => {
            if (!sessionUuid) {
                setStatus('failed');
                setError('Missing session identifier parameter.');
                return;
            }

            if (paymentLinkStatus !== 'paid' && searchParams.get('razorpay_payment_link_status') !== 'paid') {
                setStatus('failed');
                setError('Payment process was not successfully completed.');
                return;
            }

            try {
                // हमारे डेटाबेस से पेमेंट स्थिति चेक करना (Polling)
                const { data } = await api.get(`/payment/check-status/${sessionUuid}`);

                if (data.payment_status === 'paid' && isMounted) {
                    setStatus('success');
                    clearInterval(pollInterval);
                    
                    // कैंडिडेट को सीधे उसी रोल के विज़ार्ड पेज (Step 5) पर रिडायरेक्ट करें
                    navigate(`/audition/${data.role_id}/acting`);
                }
            } catch (err) {
                console.error("Polling database error:", err);
            }
        };

        if (isMounted) {
            checkUnlockStatus();
            // हर 3 सेकंड में आटोमेटिक सिंक स्टेटस चेक करना
            pollInterval = setInterval(checkUnlockStatus, 3000);
        }

        return () => {
            isMounted = false;
            clearInterval(pollInterval);
        };
    }, [paymentLinkStatus, paymentId, sessionUuid, navigate, searchParams]);

    return (
        <Container className="d-flex align-items-center justify-content-center callback-container">
            <Card className="p-5 text-center shadow-lg callback-card">
                {status === 'verifying' && (
                    <div>
                        <Spinner animation="border" variant="danger" className="mb-4" style={{ width: '3rem', height: '3rem' }} />
                        <h4 className="callback-title">Verifying Your Payment</h4>
                        <p className="callback-text mt-3">
                            Please wait. We are unlocking your secure audition booking session. Do not close or refresh this window.
                        </p>
                    </div>
                )}

                {status === 'failed' && (
                    <div>
                        <Alert className="mb-4 text-start border-0 callback-alert-danger">
                            <h5 className="font-bold">Verification Error</h5>
                            <p className="small mb-0">{error}</p>
                        </Alert>
                        <p className="callback-text mb-4">If your money was deducted, please contact support for manual activation.</p>
                        <Button className="callback-btn-primary w-100" onClick={() => navigate('/')}>
                            Go to Homepage
                        </Button>
                    </div>
                )}
            </Card>
        </Container>
    );
};

export default PaymentCallback;